import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CatalogViewComponentDef } from '@df/catalog-ui/catalog-view.component.def';
import { GiftcardsCategoryViewComponent } from '../../module/giftcards/giftcards-category-view.component';
import { CategoryViewComponent } from './category/category-view.component';
import { Error404Component } from './error-404.component';
import { PageViewComponent } from './page/page-view.component';
import { ProductLayoutViewComponent } from './product/layout/view/product-layout-view.component';
import { StoreViewComponent } from './store/view/store-view.component';

@Component({
    selector: 'catalog-view',
    templateUrl: './catalog-view.html',
    standalone: true,
    imports: [
        CategoryViewComponent,
        Error404Component,
        GiftcardsCategoryViewComponent,
        PageViewComponent,
        ProductLayoutViewComponent,
        StoreViewComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogViewComponent extends CatalogViewComponentDef {}
